import React, {FC, ReactNode} from 'react';

import {Handler} from '../../../../helpers/src/react/reactHelpers';
import {IconButton} from '../buttons/iconButton';
import {Dropdown, DropdownProps} from './dropdown';
import {DropdownFooter} from './dropdownFooter';
import {DropdownHeader} from './dropdownHeader';
import {DropdownList} from './dropdownList';

/*
 * Props.
 */

export interface SimpleDropdownWithHeaderProps extends DropdownProps {
  title: ReactNode;
  backButtonLabel?: ReactNode;
  onBackButtonClick?: Handler;
  footer?: ReactNode;
}

/*
 * Component.
 */

export const SimpleDropdownWithHeader: FC<SimpleDropdownWithHeaderProps> = (props) => (
  <Dropdown {...props}>
    <DropdownHeader title={props.title} leftIcon={maybeRenderBackButton(props)} />
    <DropdownList {...props}>{props.children}</DropdownList>
    {props.footer && <DropdownFooter>{props.footer}</DropdownFooter>}
  </Dropdown>
);

function maybeRenderBackButton(props: SimpleDropdownWithHeaderProps) {
  if (!props.backButtonLabel || !props.onBackButtonClick) {
    return null;
  }

  return (
    <IconButton iconName="chevronLeftSmall" label={props.backButtonLabel} onClick={props.onBackButtonClick} />
  );
}
